import { useState } from "react";
import styles from "./UpdateDrawer.module.css";
import Button from "../../Dealers/Button";
import { ProgressBar } from "../ProgressBar";
import { formatDateTime } from "../../../../Utils/Utils";
// ─── Update Drawer ────────────────────────────────────────────────────────────
export const UpdateDrawer = ({ item, mode, onClose, onSave, activeTab }) => {
  const [productionQty, setProductionQty] = useState("");
  const [machine, setMachine] = useState(item?.machine || "Extruder 1");
  const [status, setStatus] = useState(item?.status || "Pending");

  if (!item) return null;

  const addQty = (qty) => {
    setProductionQty((prev) => (Number(prev) || 0) + qty);
  };

  const handleComplete = () => {
    setProductionQty(item.pendingQty);
    setStatus("Completed");
  };

  const requiredQty = item.requiredQty || 0;
  const producedQty = item.producedQty || 0;
  const entryQty = Number(productionQty) || 0;

  const totalProduced = producedQty + entryQty;
  const remainingQty = Math.max(requiredQty - totalProduced, 0);
  const extraQty = Math.max(totalProduced - requiredQty, 0);

  const handleSave = () => {
    const qty = Number(productionQty);

    if (!qty || qty <= 0) {
      alert("Enter a valid Production Qty");
      return;
    }

    onSave({ item, qty, machine, status });
    onClose();
  };

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div
        className={`${styles.updateDrawer} ${mode ? styles.updateDrawerDark : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className={styles.drawerHeader}>
          <h2>Update Production</h2>
          <button onClick={onClose}>✕</button>
        </div>

        {/* Body */}
        <div className={styles.drawerBody}>
          <div className={styles.infoGrid}>
            <div className={styles.infoCard}>
              <span>Item No</span>
              <strong>{item.itemCode}</strong>
            </div>
            <div className={styles.infoCard}>
              <span>Required Qty</span>
              <strong>{item.requiredQty}</strong>
            </div>
            <div className={styles.infoCard}>
              <span>Produced Qty</span>
              <strong style={{ color: "#12b76a" }}>{item.producedQty}</strong>
            </div>
            <div className={styles.infoCard}>
              <span>Pending Qty</span>
              <strong
                style={{ color: item.pendingQty > 0 ? "#f04438" : "#12b76a" }}
              >
                {item.pendingQty}
              </strong>
            </div>
          </div>

          <div style={{ marginBottom: 16 }}>
            <ProgressBar
              produced={item.producedQty}
              required={item.requiredQty || 1}
              mode={mode}
            />
          </div>
          {extraQty > 0 ? (
            <div
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#F79009",
                marginBottom: 12,
              }}
            >
              ⚠️ Extra Production: {extraQty} units.
              <br />
              extra production quantity add to order.
            </div>
          ) : (
            remainingQty !== 0 &&
            extraQty === 0 && (
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#12B76A",
                  marginBottom: 12,
                }}
              >
                ✅ Current qty update to the order and finish for production
              </div>
            )
          )}

          {remainingQty === 0 && extraQty === 0 && (
            <div
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "#12B76A",
                marginBottom: 12,
              }}
            >
              ✅ Required production quantity completed successfully.
            </div>
          )}
          <div>
            {item?.qtyHistory?.length > 0 && (
              <>
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: mode ? "#fff" : "#111",
                    marginBottom: 8,
                  }}
                >
                  📋 Production History ({item.qtyHistory.length} update
                  {item.qtyHistory.length > 1 ? "s" : ""})
                </div>

                <div
                  style={{
                    maxHeight: 180,
                    overflowY: "auto",
                    paddingRight: 4,
                    backgroundColor: mode ? "#1B1D21" : "#F5F7FB",
                    padding: "6px 10px",
                    borderRadius: 10,
                    marginBottom: 16,
                  }}
                >
                  {item.qtyHistory.map((h, idx) => (
                    <div
                      key={idx}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "6px 0",
                        borderBottom:
                          idx !== item.qtyHistory.length - 1
                            ? `1px solid ${mode ? "#3b3d43" : "#E5E7EB"}`
                            : "none",
                      }}
                    >
                      <div>
                        <span
                          style={{
                            color: "#12B76A",
                            fontWeight: 600,
                            fontSize: 14,
                          }}
                        >
                          +{h.qty} units
                        </span>
                      </div>

                      <span
                        style={{
                          color: mode ? "#ffffff" : "#6B7280",
                          fontSize: 11,
                          fontWeight: 500,
                        }}
                      >
                        Admin{" / "} {formatDateTime(h.ts)}
                      </span>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
          <div className={styles.formGroup}>
            <label>Add Production Qty</label>
            <input
              type="number"
              value={productionQty}
              onChange={(e) => setProductionQty(e.target.value)}
              placeholder="Enter qty..."
            />
          </div>

          <div className={styles.quickBtns}>
            {/* <button onClick={() => addQty(10)}>+10</button>
            <button onClick={() => addQty(20)}>+20</button> */}
            <Button
              buttonClick={handleComplete}
              buttonBgColor={"#4164E3"}
              buttonTextColor={"#ffffff"}
              buttonText={"Complete"}
            />
          </div>

          {activeTab !== "Order Wise" && (
            <div className={styles.formGroup}>
              <label>Machine</label>
              <select
                value={machine}
                onChange={(e) => setMachine(e.target.value)}
              >
                <option>Extruder 1</option>
                <option>Extruder 2</option>
                <option>Extruder 3</option>
              </select>
            </div>
          )}

        
            <div className={styles.formGroup}>
              <label>Status</label>
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option>Pending</option>
                <option>In Production</option>
                <option>Completed</option>
              </select>
            </div>
        
        </div>

        {/* Footer */}
        <div className={styles.drawerFooter}>
          <Button
            buttonClick={onClose}
            buttonText={"Close"}
            buttonBgColor={"#000000"}
            buttonTextColor={"#ffffff"}
          />

          <Button
            buttonClick={handleSave}
            buttonText={"Save Update"}
            buttonBgColor={"#4164E3"}
            buttonTextColor={"#ffffff"}
          />
        </div>
      </div>
    </div>
  );
};
